import type { ReactNode } from 'react'

type LandingLeadInputProps = {
  children: ReactNode
  error?: string
  label: string
}

export function LandingLeadInput({ children, error, label }: LandingLeadInputProps) {
  return (
    <label className="block">
      <span className="mb-2 block text-sm font-medium text-phosphor-ivory">{label}</span>
      {children}
      {error ? (
        <span className="mt-2 block text-sm leading-6 text-fault-red" role="alert">
          {error}
        </span>
      ) : null}
    </label>
  )
}
